<template>
  <div id="bg-image">
    <registration-success-page />
  </div>
</template>

<script>
import RegistrationSuccessPage from '../process/Register/RegistrationSuccessPage.vue';
    export default {
        name: 'RegistrationSuccess',
        components: {
            RegistrationSuccessPage,
        },
    };
</script>

<style scoped>

</style>
